// extracted by mini-css-extract-plugin
export default {"root":"OrgManage_root__ds5DL"};